import { render, staticRenderFns } from "./ProductDescriptions.vue?vue&type=template&id=6cfce3ca&scoped=true&"
import script from "./ProductDescriptions.vue?vue&type=script&lang=js&"
export * from "./ProductDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./ProductDescriptions.vue?vue&type=style&index=0&id=6cfce3ca&scoped=true&lang=sass&"
import style1 from "./ProductDescriptions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfce3ca",
  null
  
)

export default component.exports